import React, { Component } from "react";
import styled, { keyframes } from "styled-components";
import { connect } from "react-redux";
import StyleLink from "./dev/StyleLink";
import axios from "axios";
import LoadingList from "./Lottery/LoadingList";
import convertDate from "./dev/convertDate";
import ProgressBar from "./dev/ProgressBar";
import CheckIsNumber from "./dev/validation/CheckIsNumber";
import PaymentBanner from "./Payment/PaymentBanner";

const { REACT_APP_URI = "/" } = process.env;

class Lottery extends Component {
  state = {
    condition: {
      videoId: "",
      videoUrl: "",
      keyword: "",
      number: "",
    },
    status: "",
    commentsList: {},
    winnerList: [],
    isResultKeywordMatched: true,
    isResultNumberMatched: true,
    isLoading: false,
  };
  lotteryInput = (name) => (e) =>
    this.setState({
      condition: {
        ...this.state.condition,
        [name]: this.toHalfWidth(e.target.value),
      },
    });
  lotterySubmit = () => {
    const { getVideoId, setVideoToCommentList, getComments } = this;
    const { videoUrl, number } = this.state.condition;
    const {
      user: { plan },
    } = this.props;
    //權限不足
    if (plan === "" || plan === "Free") return;
    // reset state
    this.setState({
      status: "",
      isResultNumberMatched: true,
      isResultKeywordMatched: true,
    });
    if (videoUrl === "") return this.setState({ status: 400 });
    if ((!CheckIsNumber(number) || number < 0) && number !== "")
      return this.setState({ status: "NumberError" });
    // loading start
    this.setState({
      isLoading: true,
    });
    getVideoId(videoUrl).then(setVideoToCommentList).then(getComments);
  };
  getVideoId = (url) =>
    new Promise((resolve, reject) => {
      const urlsetting = new URL(url);
      const { hostname, pathname } = urlsetting;
      const videoId =
        hostname === "youtu.be"
          ? pathname.substring(1)
          : urlsetting.searchParams.get("v"); // 從 url 取得 videoId，並判斷是否為縮網址
      if (videoId === null)
        // 網址格式錯誤，斷
        this.setState(
          {
            condition: { ...this.state.condition, videoId: "" },
            status: 400,
            isLoading: false,
          },
          reject
        );
      else
        this.setState(
          {
            condition: {
              ...this.state.condition,
              videoId: videoId,
            },
          },
          resolve
        );
    });
  setVideoToCommentList = () =>
    new Promise((resolve, reject) => {
      const { token } = this.props.user;
      const {
        condition: { videoId },
        commentsList,
      } = this.state;
      if (commentsList[videoId] !== undefined) {
        //代表已經抓過該影片留言，進度未知，下一步 getComments
        resolve();
      } else {
        fetch(`${REACT_APP_URI}/Lottery/CommentCount/`, {
          method: "post",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": token,
          },
          body: JSON.stringify({ videoId: videoId }),
        })
          .then((res) => {
            if (res.ok) return res.json();
            else {
              if (res.status === 400)
                throw this.setState({ status: 400, isLoading: false }, reject); //無該影片
              if (res.status === 503 || res.status === 500)
                //yt未知錯誤，3秒後重試
                throw setTimeout(() => {
                  reject();
                  this.lotterySubmit();
                }, 1000);
            }
          })
          .then(({ commentCount }) => {
            this.setState(
              {
                commentsList: {
                  ...commentsList,
                  [videoId]: {
                    ...commentsList[videoId],
                    mustGetAmount: commentCount,
                    alreadyGetAmount: 0,
                    isComplete: false,
                    nextPageToken: "",
                  },
                },
              },
              resolve
            );
          });
      }
    });
  makeCancelableRequest = () => {
    let call;
    return (url, data, condition) => {
      if (call) {
        call.cancel("cancel previous request");
      }
      call = axios.CancelToken.source();
      return axios.post(url, data, {
        ...condition,
        cancelToken: call.token,
      });
    };
  };
  post = this.makeCancelableRequest();
  getComments = (cuurentVideoId) =>
    new Promise((resolve, reject) => {
      const {
        state: {
          condition: { videoId },
          commentsList,
        },
        props: {
          user: { token },
        },
        post,
        lotteryWinner,
      } = this;
      cuurentVideoId = cuurentVideoId === undefined ? videoId : cuurentVideoId;
      if (cuurentVideoId !== videoId) return reject(); // 使用者在還沒抓完完整留言時 request 另一隻影片，斷
      const {
        mustGetAmount,
        alreadyGetAmount,
        nextPageToken,
        isComplete,
        comments = [],
      } = commentsList[videoId];
      // console.log(
      //     `mustGetAmount: ${mustGetAmount}, alreadyGetAmount: ${alreadyGetAmount}`
      // );
      if (isComplete) lotteryWinner();
      // 已經抓完的情況，開抽
      else {
        //還沒抓完
        post(
          `${REACT_APP_URI}/Lottery/Comments/`,
          { videoId: videoId, requestPageToken: nextPageToken },
          {
            headers: {
              "Content-Type": "application/json",
              "X-CSRFToken": token,
            },
            withCredentials: true,
          }
        )
          .then((res) => {
            if (res.status === 200) {
              this.setState({ status: res.status });
              return res.data;
            } else
              throw setTimeout(() => {
                this.lotterySubmit();
              }, 3000);
          })
          .then((res) => {
            this.setState(
              {
                commentsList: {
                  ...commentsList,
                  [videoId]: {
                    ...commentsList[videoId],
                    mustGetAmount: mustGetAmount - res.replyCount,
                    alreadyGetAmount: alreadyGetAmount + res.comments.length,
                    isComplete: res.nextPageToken === null,
                    nextPageToken: res.nextPageToken,
                    comments: [...comments, ...res.comments],
                  },
                },
              },
              () => this.getComments(videoId) //繼續下100隻留言直到 isComplete === true
            );
          });
      }
    }).catch((err) => console.log(`getComments error: ${err}`));
  // ------------ 關鍵字搜尋，堪用，但感覺應該可以寫得更好，待重構 by Yen
  toHalfWidth = (char) =>
    char.replace(/[\uff01-\uff5e]/g, (i) =>
      String.fromCharCode(i.charCodeAt(0) - 0xfee0)
    );
  removeSpace = (char) => char.replace(/\s+/g, "");
  toUnicode(theString) {
    var unicodeString = "";
    for (var i = 0; i < theString.length; i++) {
      var theUnicode = theString.charCodeAt(i).toString(16).toUpperCase();
      while (theUnicode.length < 4) {
        theUnicode = "0" + theUnicode;
      }
      theUnicode = "\\u" + theUnicode;
      unicodeString += theUnicode;
    }
    return unicodeString;
  }
  matchKeyword = (comments) => {
    const {
      condition: { keyword },
    } = this.state;
    const { toHalfWidth, toUnicode, removeSpace } = this;
    const commentsMatchKeyword = comments.filter((i) => {
      if (
        escape(
          toUnicode(toHalfWidth(removeSpace(i.text.toLowerCase())))
        ).search(
          escape(toUnicode(toHalfWidth(removeSpace(keyword.toLowerCase()))))
        ) >= 0
      ) {
        return i;
      } else return false;
    });
    if (commentsMatchKeyword === []) {
      //留言數不足或符合關鍵字留言數不足
      this.setState({ isResultKeywordMatched: false });
      return comments;
    } else {
      this.setState({ isResultKeywordMatched: true });
      return commentsMatchKeyword;
    }
  };
  // ------------ 關鍵字搜尋，堪用，但感覺應該可以寫得更好，待重構 End
  matchWinnerNumber = (comments) => {
    const {
      condition: { number },
    } = this.state;
    if (number === "" || number > comments.length) {
      number === ""
        ? this.setState({ isResultNumberMatched: true })
        : this.setState({ isResultNumberMatched: false });
      return comments;
    } else {
      this.setState({ isResultNumberMatched: true });
      let list = [...comments];
      let winner = [];
      for (let i = 0; i < number; i++) {
        let num = Math.floor(Math.random() * list.length);
        winner = [...winner, list.splice(num, 1)[0]];
      }
      return winner;
    }
  };
  lotteryWinner = () => {
    const {
      condition: { videoId },
    } = this.state;
    const { matchKeyword, matchWinnerNumber } = this;
    const { comments } = this.state.commentsList[videoId];
    const winnerList = matchWinnerNumber(matchKeyword(comments));
    this.setState({ winnerList: winnerList, status: 200 }, () =>
      setTimeout(() => {
        this.setState({ isLoading: false });
      }, 500)
    ); //為了讓進度條跑滿讓他多跑0.5秒ㄏㄏ
  };
  renderLotteryInput = () => {
    const { lotteryInput, lotterySubmit } = this;
    const {
      condition: { videoUrl, keyword, number },
    } = this.state;
    const {
      messages,
      user: { plan },
    } = this.props;
    return (
      <LotteryField>
        <TitleField>
          <Title>
            <div>{messages["lottery_title_01"]}</div>
            <div>{messages["lottery_title_02"]}</div>
          </Title>
          <SubTitle>{messages.lottery_intro}</SubTitle>
        </TitleField>
        <InputWrapper mask={plan === "" || plan === "Free"}>
          <div>
            <SubTitle bold>{messages.lottery_url}</SubTitle>
            <Input
              onChange={lotteryInput(`videoUrl`)}
              value={videoUrl}
              type="text"
              placeholder={"https://www.youtube.com/watch?v=XXXXXXXXXXX"}
            />
          </div>
          <div>
            <SubTitle bold>{messages.lottery_keyword}</SubTitle>
            <Input
              onChange={lotteryInput(`keyword`)}
              value={keyword}
              type="text"
              placeholder={messages.lottery_nokeyword}
            />
          </div>
          <div>
            <SubTitle bold>{messages.lottery_winners}</SubTitle>
            <SubmitWrap>
              <Input
                onChange={lotteryInput(`number`)}
                value={number}
                type="text"
                placeholder={messages.lottery_number}
                small
                last
              />
              <Submit onClick={lotterySubmit}>{messages.lottery_start}</Submit>
            </SubmitWrap>
          </div>
        </InputWrapper>
      </LotteryField>
    );
  };
  result = (List) => {
    const { isLoading } = this.state;
    return List.map(({ author, text, date }) => {
      return (
        <ResultListField>
          <ResultName isLoading={isLoading}>{author}</ResultName>
          <ResultContent isLoading={isLoading}>{text}</ResultContent>
          <ResultTime isLoading={isLoading}>{convertDate(date)}</ResultTime>
        </ResultListField>
      );
    });
  };
  renderResult = () => {
    const {
      status,
      isLoading,
      isResultKeywordMatched,
      isResultNumberMatched,
    } = this.state;
    const { messages } = this.props;
    return (
      status !== "" && (
        <ResultField>
          {!isResultKeywordMatched && ( //沒有符合 keyowrd 留言，render 所有留言
            <ErrorTitle>{messages.lottery_keyword_error}</ErrorTitle>
          )}
          {!isResultNumberMatched && ( //符合 keyowrd 留言少於總留言，render 所有符合 keyowrd 留言
            <ErrorTitle>{messages.lottery_amount_error}</ErrorTitle>
          )}
          {status === 400 ? (
            <ErrorTitle>{messages.lottery_url_error}</ErrorTitle>
          ) : status === "NumberError" ? (
            <ErrorTitle>{messages.lottery_please_number}</ErrorTitle>
          ) : (
            !isLoading &&
            status === 200 && (
              <React.Fragment>
                <ResultTitle>{messages.lottery_result}</ResultTitle>
                <ResultTitleField>
                  <ResultName>{messages.lottery_name}</ResultName>
                  <ResultContent>{messages.lottery_content}</ResultContent>
                  <ResultTime>{messages.lottery_time}</ResultTime>
                </ResultTitleField>
                {this.result(this.state.winnerList)}
              </React.Fragment>
            )
          )}
        </ResultField>
      )
    );
  };
  renderLoadingResult = () => {
    const { messages } = this.props;
    const {
      condition: { videoId },
      commentsList,
    } = this.state;
    const { alreadyGetAmount, mustGetAmount } =
      commentsList[videoId] === undefined
        ? { alreadyGetAmount: 0, mustGetAmount: 100 }
        : commentsList[videoId];
    return (
      <ResultField>
        <ProgressBar
          value={(alreadyGetAmount / mustGetAmount) * 100}
          text={`${messages.lottery_please_wait}(${Math.floor(
            (alreadyGetAmount / mustGetAmount) * 100
          )})%`}
          barColor="#e94242"
        />
        <ResultTitleField>
          <ResultName>{messages.lottery_name}</ResultName>
          <ResultContent>{messages.lottery_content}</ResultContent>
          <ResultTime>{messages.lottery_time}</ResultTime>
        </ResultTitleField>
        {this.result(LoadingList)}
      </ResultField>
    );
  };
  render() {
    const { isLoading } = this.state;
    const { messages } = this.props;
    const { renderResult, renderLoadingResult, renderLotteryInput } = this;
    return (
      <Container>
        <Wrapper>
          {renderLotteryInput()}
          {isLoading ? renderLoadingResult() : renderResult()}
          <StyleLink to="/" color="#de0606" center>
            {messages.lottery_goto_rank}
          </StyleLink>
          {/* <ProgressBar value={60} text={`${messages.lottery_please_wait}(60)%`} barColor="#e94242"/> */}
        </Wrapper>
        <PaymentBanner bannerPlan={"Creator"} />
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.User,
    messages: state.Messages,
  };
};
export default connect(mapStateToProps)(Lottery);

const Loading = keyframes`
    0%, 100% {
        opacity: .15;
    }
    50% {
        opacity: .05;
    }
`;
const Container = styled.div`
  min-height: calc(100vh - 72px);
  background-color: #fafafa;
  border-left: 1px solid #e6e6e6;
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: auto;
  padding: 50px 0;
  @media (max-width: 900px) {
    padding: 0;
  }
`;
const LotteryField = styled.div`
  display: flex;
  justify-content: space-between;
  width: 900px;
  padding: 48px;
  margin-bottom: 20px;
  background-color: #fff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
  color: #787878;
  @media (max-width: 900px) {
    width: 100%;
    padding: 10px;
  }
`;
const TitleField = styled.div`
  width: 60%;
  padding-right: 20px;
  @media (max-width: 900px) {
    display: none;
  }
`;
const Title = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  font-size: 28px;
  font-weight: 500;
  transform: ${(props) => (props.right ? "translateX(-28px)" : "")};
  @media (max-width: 900px) {
    margin-bottom: 0;
    font-size: 16px;
  }
`;
const SubTitle = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  font-weight: ${(props) => (props.bold ? "500" : "300")};
  @media (max-width: 900px) {
    font-size: 14px;
  }
`;
const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 40%;
  ${({ mask }) => mask && "filter: blur(3px); pointer-events: none"};
  @media (max-width: 900px) {
    justify-content: space-between;
    width: 100%;
  }
`;
const Input = styled.input`
  width: ${(props) => (props.small ? "50%" : "100%")};
  padding-left: 10px;
  margin: 10px 0;
  ${({ last }) => (last ? "margin: 10px 0 0 0" : "")};
  background-color: transparent;
  border: 0.5px solid #979797;
  font-size: 14px;
  line-height: 1.8em;
  color: #666666;
  ::-webkit-input-placeholder {
    color: #999999;
    font-weight: 300;
  }
  &:focus {
    outline: none;
  }
  @media (max-width: 900px) {
    font-size: 12px;
  }
`;
const SubmitWrap = styled.div`
  display: flex;
  justify-content: space-between;
`;
const Submit = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  background-color: #de0606;
  color: #fff;
  cursor: pointer;
`;
const ResultField = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 900px;
  margin-bottom: 20px;
  @media (max-width: 900px) {
    width: 100%;
  }
`;
const ResultTitle = Title.extend`
  align-items: center;
  width: 100%;
`;
const ErrorTitle = Title.extend`
  align-items: center;
  color: #de0606;
  margin-bottom: 10px;
`;
const ResultListField = styled.div`
  /* display: flex; */
  /* justify-content: space-between; */
  display: grid;
  grid-template-columns: 150px 550px auto;
  grid-template-rows: 1fr;
  grid-template-areas: "name content time";
  width: 100%;
  padding: 10px 0;
  font-size: 20px;
  font-weight: 500;
  color: #787878;
  border-bottom: 0.3px solid #c0c0c0;
  &:nth-child(1) {
    border-top: 0.3px solid #c0c0c0;
  }
  @media (max-width: 900px) {
    grid-template-columns: auto 140px;
    grid-template-rows: auto auto;
    grid-template-areas:
      "name time"
      "content content";
  }
`;
const ResultTitleField = ResultListField.extend`
  border-bottom: 1px solid #666;
  @media (max-width: 900px) {
    display: none;
  }
`;
const ResultName = styled.div`
  grid-area: name;
  ${(props) =>
    props.isLoading
      ? `color: transparent; background-color: #787878; background-size: 50% 100%; border-radius: 20px; animation: ${Loading} 2s infinite;`
      : ""}
  @media (max-width: 900px) {
    margin: 0 5px;
    font-size: 12px;
  }
`;
const ResultContent = styled.div`
  grid-area: content;
  ${(props) =>
    props.isLoading
      ? `color: transparent; background-color: #787878; border-radius: 20px; animation: ${Loading} 2s infinite;`
      : ""}
  @media (max-width: 900px) {
    margin: 10px 10px 0 10px;
    font-size: 14px;
  }
`;
const ResultTime = styled.div`
  grid-area: "time";
  ${(props) =>
    props.isLoading
      ? `color: transparent; background-color: #787878; border-radius: 20px; animation: ${Loading} 2s infinite;`
      : ""}
  @media (max-width: 900px) {
    font-size: 12px;
  }
`;

const Attention = styled.div`
  display: flex;
  color: ${({ red }) => (red ? "#e94242" : "")};
  font-size: 16px;
  margin-bottom: 16px;
`;



// WEBPACK FOOTER //
// ./src/Lottery.js